/* eslint-disable @nx/enforce-module-boundaries */
import { SaveSearchButton } from '@aibees/elephant/components/save-search-button';
import { useDataViewChartView } from '@aibees/elephant/context/data-view-context';
import { DataViewSwitcher } from '@aibees/elephant/feature/search-table-company/components/data-view-switcher';
import {
  useSearchRouteInfo,
  useTableLayoutConfig,
} from '@aibees/elephant/hooks';
import { FeatureFlags } from '@aibees/elephant/types';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';
import { TableLayoutModifier } from '@aibees/shared/features/advance-table/components/table-layout-modifier';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { classnames } from '@aibees/shared/utils';
import { Divider, Stack, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import { SearchTableHeaderButton } from '../search-table-header-button';
import { SearchTotalTabs } from '../search-total-tabs';
import { ShareLinkButton } from '../share-link-button';
import * as Styled from './styles';

export const SearchTotal = memo(({ className }: { className?: string }) => {
  const isEnabled = useFeatureFlagsContext().isFeatureEnabled(
    FeatureFlags.SEARCH_TABLE_COLUMN_MODIFIER
  );
  const { presetType, type } = useSearchRouteInfo();
  const { tableLayoutModifierDialogState } = useTableLayoutTemplateContext();

  const isSmall = useMediaQuery('(max-width:1250px)');

  const { isChartView } = useDataViewChartView();

  const { groupedItems, label } = useTableLayoutConfig(type);

  const handleOpenTableLayoutModifier = () => {
    tableLayoutModifierDialogState.onTrue();
  };

  return (
    <Styled.Wrapper
      className={classnames('SearchTotal', className)}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <SearchTotalTabs />

      {isChartView ? (
        <DataViewSwitcher />
      ) : (
        <Stack
          direction="row-reverse"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <ShareLinkButton compact={isSmall} />

          <Divider orientation="vertical" flexItem sx={{ mx: -0.5 }} />

          {isEnabled && (
            <TableLayoutModifier
              element={
                <SearchTableHeaderButton
                  compact={isSmall}
                  text="Edit Columns"
                  icon="columns"
                  variant="text"
                  color="default"
                  onClick={handleOpenTableLayoutModifier}
                />
              }
              config={{ groupedItems, label }}
            />
          )}

          <SaveSearchButton presetType={presetType} compact={isSmall} />
        </Stack>
      )}
    </Styled.Wrapper>
  );
});

SearchTotal.displayName = 'SearchTotal';
